import { useEffect, useState } from "react";
import OrbitalCities from "@/components/OrbitalCities";
import MobileCities from "@/components/MobileCities";

export default function Cities() {
    const [isMobile, setIsMobile] = useState(
        typeof window !== "undefined" && window.innerWidth < 768,
    );
    useEffect(() => {
        const on = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener("resize", on);
        return () => window.removeEventListener("resize", on);
    }, []);
    return isMobile ? <MobileCities /> : <OrbitalCities />;
}
